import React from 'react';

const AboutMe = () => {
    return (
        <div>
            <section className=" text-black font-normal">
                <div className="container flex flex-col justify-center p-12 mx-auto sm:py-16 lg:py-24 lg:flex-row lg:justify-around">
                    <div className="flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left">
                        <h1 className="text-3xl font-semibold font-serif leading-none sm:text-5xl text-black">About Me!
                            <div className="divider"></div>
                        </h1>



                        <div className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">


                        </div>
                    </div>
                    <div className="flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128">
                        <div>
                            I'm Creative Director and React Developer from <br /> Khulna, Bangladesh, working in web development and print media. <br /> I enjoy turning complex problems into simple, <br /> beautiful and intuitive designs.

                            My aim is to bring across your message <br />
                            and identity in the most creative way. I <br /> created web design for many famous brand companies.

                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutMe;